<template>
    <div></div>
  </template>
  
  <script>
  export default {
    name: 'logout',
    created() {
      this.performLogout();
    },
    methods: {
      performLogout() {
        this.$auth.logout().then(() => {
          this.$router.push('/login');
        }).catch((error) => {
          console.error('Erro ao fazer logout:', error);
          this.$router.push('/login');
        });
      }
    }
  }
  </script>